import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {UserDefaultState} from './models/user-default-state.enum';

@Injectable()
export class DefaultStateService {
  public state: BehaviorSubject<UserDefaultState> = new BehaviorSubject(UserDefaultState.home);

  constructor() {
  }

}
